import React from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'
import { DragOverlay as DndDragOverlay } from '@dnd-kit/core'
import { restrictToWindowEdges } from '@dnd-kit/modifiers'
import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'
import { PersonListItemDisplay } from './PersonListItem'

const overlayContainerCss = css`
  position: relative;
  width: 100%;
  min-height: 3.25rem;
`

const overlayCardCss = css`
  box-shadow: 0 0 0.3125rem rgb(68 68 68 / 0.6);
  background: ${colors.white100};
  border-radius: 0.25rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`

const PersonDragOverlay = ({ dragInfo }) => {
  const [t] = useTranslation()

  if (!dragInfo?.person) {
    return null
  }

  return createPortal(
    <DndDragOverlay modifiers={[restrictToWindowEdges]} dropAnimation={null}>
      <div css={overlayContainerCss} data-testid="person-drag-overlay-container">
        <div css={overlayCardCss}>
          <PersonListItemDisplay person={dragInfo.person} record={dragInfo.record} t={t} />
        </div>
      </div>
    </DndDragOverlay>,
    document.body
  )
}

export default PersonDragOverlay
